// @ts-check
import jwt from "jsonwebtoken";

const Key1 = "Medicaltec3101";
const Key2 = "Medicaltec310188";

/**
 * @param {Object} payload
 * @param {jwt.SignOptions} [options]
 * @returns {string}
 */
function SingJWT(payload, options) {
  return jwt.sign(payload, Key1, options);
}

/**
 * @param {Object} payload
 * @param {jwt.SignOptions} [options]
 * @returns {string}
 */
function SingJWT2(payload, options) {
  return jwt.sign(payload, Key2, options);
}

/**
 * @param {string} token
 * @returns {Object}
 */
function VerifyJWT(token) {
  try {
    return jwt.verify(token, Key1);
  } catch (error) {
    throw error;
  }
}

export { SingJWT, VerifyJWT, SingJWT2 };
